import { useState, useCallback, useRef, useEffect } from 'react'
import { Modal } from '@/components/Modal'
import { Button } from '@/components/Button'
import { Tooltip } from '@/components/Tooltip'

interface ShareModalProps {
	open: boolean
	onClose: () => void
}

export function ShareModal ({ open, onClose }: ShareModalProps) {
	const [copied, setCopied] = useState(false)
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined)

	const handleCopyLink = useCallback(async () => {
		await navigator.clipboard.writeText(window.location.href)
		setCopied(true)
		clearTimeout(timeoutRef.current)
		timeoutRef.current = setTimeout(() => { setCopied(false) }, 2000)
	}, [])

	useEffect(() => () => { clearTimeout(timeoutRef.current) }, [])

	const emailHref = `mailto:?subject=Check out this great home I found on ${window.location.hostname}&body=${encodeURIComponent(window.location.href)}`
	const smsHref = `sms:?body=${encodeURIComponent(window.location.href)}`

	return (
		<Modal
			open={open}
			onClose={onClose}
			title='Share'
			spacesClass='spaces-share-modal'
			fitContent
		>
			<div className='spaces:flex spaces:flex-col spaces:gap-16'>
				<Tooltip
					label='Link copied!'
					placement='top'
					role='status'
					open={copied}
					className='spaces:w-full'
				>
					<Button
						label='Copy Link'
						iconLeft='Link'
						appearance='stroke'
						color='content2'
						size='md'
						onClick={handleCopyLink}
						className='spaces:w-full'
					/>
				</Tooltip>
				<Button
					label='Email'
					iconLeft='Mail'
					appearance='stroke'
					color='content2'
					size='md'
					href={emailHref}
					className='spaces:w-full'
				/>
				<Button
					label='Message'
					iconLeft='MessageCircle'
					appearance='stroke'
					color='content2'
					size='md'
					href={smsHref}
					className='spaces:w-full'
				/>
			</div>
		</Modal>
	)
}
